import { authHeader } from '@/helpers/auth-header'
import { commons } from './commons'

export const containerTrackingErrorService = {
    browse,
}

const resourceUrl = process.env.VUE_APP_GSCV_ENGINE_URL + `/container-errors`

function browse(offset, limit, filter, sortingList) {
    if (!sortingList.length) {
        sortingList = []
    }
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            offset: offset,
            limit: limit,
            filter: filter,
            sortingList: sortingList,
        }),
    }
    return fetch(resourceUrl + `/browse`, requestOptions).then(
        commons.handleJsonResponse,
    )
}